import React from 'react';
import TeacherDashboardMinimal from '../components/TeacherDashboardMinimal';

const TeacherDashboardPage = () => {
  return (
    <div>
      <TeacherDashboardMinimal />
    </div>
  );
};

export default TeacherDashboardPage;
